// centered section title flanked by horizontal rules (CameraX style)
export default function SectionHeader({ title }) {
  return (
    <div className="flex items-center gap-x-6 mb-12">
      <span className="h-px flex-1 bg-border" />
      <h2 className="font-display text-2xl md:text-3xl font-medium tracking-wide text-ink whitespace-nowrap">
        {title}
      </h2>
      <span className="h-px flex-1 bg-border" />
    </div>
  );
}
